/**
 * Onboarding Service
 * Busca o estado dos Primeiros Passos do contexto ativo (#387).
 */

import apiClient from './apiClient';
import type { OnboardingStatus } from '../types/onboarding';

/** O controller responde o estado no topo do corpo, sem embrulho. */
function pareceStatus(corpo: unknown): corpo is OnboardingStatus {
  return (
    typeof corpo === 'object' &&
    corpo !== null &&
    typeof (corpo as Record<string, unknown>).perspectiva === 'string' &&
    Array.isArray((corpo as Record<string, unknown>).tracks)
  );
}

class OnboardingService {
  private baseUrl = '/onboarding';

  async getStatus(): Promise<OnboardingStatus> {
    const response = await apiClient.get<unknown>(`${this.baseUrl}/status`);

    const status = pareceStatus(response) ? response : null;
    if (!status) {
      throw new Error('Resposta de primeiros passos em formato inesperado');
    }
    return { ...status, notices: Array.isArray(status.notices) ? status.notices : [] };
  }
}

export const onboardingService = new OnboardingService();
export default onboardingService;
